import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";
import NotContent from "../../../../../components/ui/Form/NotContent";
import TablePartners from "./TablePartners";
const DataReportByPartners = (props) => {
  const { data, isLoading } = props;

  if (isLoading) {
    return (
      <div className="w-full min-h-[60vh] flex justify-center items-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className="w-full min-h-[60vh] flex justify-center items-center">
        <NotContent />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg px-4 py-2 mt-4">
      <TablePartners data={data} />
    </div>
  );
};

DataReportByPartners.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default DataReportByPartners;
